import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import { UseFormRegister, FieldValues, FieldErrors } from 'react-hook-form';
import { VALUATION_METHODS } from '../../constants';
import { formContainerSx } from '../../styles';
import { CalendarTypeFields, DaysBackField, FormHeader, ValuationMethodField } from '../FormFields';

interface ValuationSettingsFormProps {
  currentValue: string;
  watchCalendarType: string;
  canEdit: boolean;
  register: UseFormRegister<FieldValues>;
  errors?: FieldErrors;
}

function ValuationSettingsForm({
  currentValue,
  watchCalendarType,
  canEdit,
  register,
  errors = undefined,
}: ValuationSettingsFormProps) {
  const theme = useTheme();

  return (
    <Grid container data-testid='inventoryvaluationsetting-form-container' spacing={2} sx={formContainerSx(theme)}>
      <FormHeader />

      <ValuationMethodField register={register} currentValue={currentValue} canEdit={canEdit} />

      {currentValue === VALUATION_METHODS.DAILY_WEIGHTED_AVERAGE && (
        <DaysBackField register={register} errors={errors} canEdit={canEdit} />
      )}

      {currentValue === VALUATION_METHODS.MONTHLY_WEIGHTED_AVERAGE && (
        <CalendarTypeFields register={register} watchCalendarType={watchCalendarType} canEdit={canEdit} />
      )}
    </Grid>
  );
}

ValuationSettingsForm.defaultProps = {
  errors: undefined,
};

export default ValuationSettingsForm;
